import React, { ReactElement } from 'react';
import { message, Tooltip, Typography } from 'antd';
import { InfoItemStyled } from './Card.styles';
import { LinkOutlined } from '@ant-design/icons';

const { Text } = Typography;

type Props = {
  label: string;
  value: string;
};

export const CardInformationEmail = ({ label, value }: Props): ReactElement => {
  const maxWidthValue = 24;
  const widthOverPassed = value.length > maxWidthValue;

  const copyToClipboard = () => {
    if (navigator.clipboard && window.isSecureContext) {
      message.success('Email address copied to your clipboard');
      return navigator.clipboard.writeText(value);
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = value;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise<void>((res, rej) => {
        document.execCommand('copy') ? res() : rej();
        textArea.remove();
        message.success('Email address copied to your clipboard');
      });
    }
  };

  if (widthOverPassed) {
    return (
      <InfoItemStyled>
        <span>{label}</span>
        <Tooltip
          placement="topLeft"
          title={value}
          trigger={widthOverPassed ? 'hover' : ''}
        >
          <Text strong className="email-wrap">
            {value}
          </Text>
        </Tooltip>

        <Tooltip
          placement="topLeft"
          title="Copy email address"
          trigger={widthOverPassed ? 'hover' : ''}
        >
          <LinkOutlined onClick={copyToClipboard} />
        </Tooltip>
      </InfoItemStyled>
    );
  }

  return (
    <InfoItemStyled>
      <span>{label}</span>
      <Text strong>{value}</Text>
    </InfoItemStyled>
  );
};
